// extracted by mini-css-extract-plugin
export default {"Header__Section":"Header_Header__Section__JnH0-","Main__Title":"Header_Main__Title__l-TlX","Description":"Header_Description__mkaas","Header__Image":"Header_Header__Image__HWN4E"};